//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileShower from '@/views/bankGuarantee/component/file-shower';
export default {
    components: { fileShower },
    props: {
        search: {
            type: Object,
            default: () => ({
                id: '',
            }),
        },
    },
    data() {
        return {
            form: {
                auditStatus: '1',
                bhmbFileguid: '',
                /* 保函 */
                bankId: '',
                bankName: '',
                branchId: '',
                branchName: '',
                bhTypeCode: '',
                bhTypeName: '',
                bbrName: '',
                syrName: '',
                bhAmount: '',
                startTime: '',
                bhDateAmount: '',
                endTime: '',
                issueTime: '',
                proCode: '',
                proName: '',
                proType: '',
                bhxyCode: '',
                ywyName: '',
                queryCode: '',
                wzName: '',
                wzCode: '',
                /* 转开 */
                isZk: '0',
                zkYh: '中国建设银行股份有限公司',
                zkFh: '',
                zkZh: '',
                zkLxr: '',
                zkLxdh: '',
                zkzlFileguid: '',
                /* 发票 */
                isFp: '0',
                fpNsrsbh: '',
                fpDzdh: '',
                fpKhhjzh: '',
                /* 邮寄 */
                isYj: '0',
                yjSjr: '',
                yjPhone: '',
                yjDz: '',
                /* 资料 */
                zbwjFile: '',
                yyzzFile: '',
                bysFile: '',
                otherFileguid: '',
                /* 保函模板 */
                isJtrq: '0',
                isJly: '0',
                isChgcx: '0',
                isCh: '0',
                mbId: '',
                mbName: '',
                bhFormatCode: '',
                bhFormatName: '',
                bzfsCode: '',
                bzfsName: '',
                fsCode: '',
                remark: '',
            },
            zbwjFile: '',
            yyzzFile: '',
            bysFile: '',
            bhmbFileguid: '',
            wordSrc: '',
            proType: [
                { key: '省内项目', value: '省内项目' },
                { key: '省内转开', value: '省内转开' },
                { key: '省内其他格式', value: '省内其他格式' },
                { key: '省内围标串标', value: '省内围标串标' },
                { key: '省外项目', value: '省外项目' },
                { key: '省外其他情形', value: '省外其他情形' },
                { key: '省外围标串标', value: '省外围标串标' },
                { key: '省外转开', value: '省外转开' },
                { key: '甘肃项目', value: '甘肃项目' },
                { key: '安徽围标串标', value: '安徽围标串标' },
            ],
            templateList: [],

            previewDialogVisible: false,
            saveButtonContorl: true,
        };
    },
    computed: {
        startTime() {
            return this.form.startTime;
        },
    },
    watch: {
        startTime: function (n, o) {},
    },
    methods: {
        fileClick(val) {
            this.wordSrc = val;
            this.previewDialogVisible = true;
        },
        //预览
        preview() {
            var that = this;
            // this.previewDialogVisible = true;
            // return;
            this.$refs.form.$refs['form'].validate(function (valid) {
                if (valid) {
                    that.$get(
                        that.getStore('bankguart') + '/gua_order/view',
                        that.form,
                        function (data) {
                            that.wordSrc = data;
                            that.previewDialogVisible = true;
                        }
                    );
                } else {
                    return false;
                }
            });
        },
        //暂存
        save() {
            var that = this;
            this.$refs.form.$refs['form'].validate(function (valid) {
                if (valid) {
                    that.form.auditStatus = '0';
                    that.$post(
                        that.getStore('bankguart') + '/gua_order',
                        that.form,
                        function (data) {
                            that.goto('./list');
                        }
                    );
                } else {
                    return false;
                }
            });
        },
        submitHandler() {
            this.form.auditStatus = '1';
            this.$refs.form.onSubmit();
        },
        submitSuccess() {
            this.goto('./list');
        },
        cancleHandler() {
            this.goto('./list');
        },
        startTimeChange(val) {
            console.log(val);
        },
        querySearch(queryString, cb) {
            var proType = this.proType;
            var results = queryString
                ? proType.filter(this.createFilter(queryString))
                : proType;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (proType) => {
                return (
                    proType.value
                        .toLowerCase()
                        .indexOf(queryString.toLowerCase()) === 0
                );
            };
        },
        //保函有效期填入建议
        querySearchYxq: function (queryString, cb) {
            var restaurants = [
                {
                    value: '30',
                    address: '30',
                },
                {
                    value: '60',
                    address: '60',
                },
                {
                    value: '90',
                    address: '90',
                },
                {
                    value: '120',
                    address: '120',
                },
            ];
            var resultsYxq = queryString
                ? restaurants.filter(function (restaurant) {
                      return (
                          restaurant.value
                              .toLowerCase()
                              .indexOf(queryString.toLowerCase()) === 0
                      );
                  })
                : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(resultsYxq);
        },
        //设置保函有效期后  计算终止时间
        setTIme: function (e) {
            if (this.form.startTime && this.form.bhDateAmount) {
                var startTime = this.form.startTime;
                startTime = / /.test(startTime)
                    ? startTime.split(' ')[0]
                    : startTime;
                var date = new Date(startTime.replace(/\-/gi, '/')).getTime();
                this.form.endTime = this.timestampToTime(
                    date + (this.form.bhDateAmount - 1) * 86400000
                );
            }
        },
        timestampToTime: function (timestamp) {
            var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M =
                (date.getMonth() + 1 < 10
                    ? '0' + (date.getMonth() + 1)
                    : date.getMonth() + 1) + '-';
            var D = date.getDate();
            if (D <= 9) {
                D = '0' + D;
            }
            return Y + M + D;
        },
        GenNonDuplicateID() {
            //获取随机字符串
            let idStr = Date.now().toString(36);
            idStr += Math.random().toString(36).substr(3);
            return idStr;
        },
        fielUploadSuccess(type) {
            //文件上传成功
            this.form[type] = this[type];
        },
        bzfsSelectChange(item) {
            //this.queryTemplateList();
        },
        mbSelectVisiblechange() {
            this.queryTemplateList(false);
        },
        queryTemplateList(clear) {
            this.templateList = [];
            if (clear) {
                this.form.mbName = '';
                this.form.mbId = '';
            }
            var that = this;
            this.$get(
                this.getStore('template') + '/all',
                {
                    bzfsCode: this.form.bzfsCode,
                    isChgcx: this.form.isChgcx,
                    isJly: this.form.isJly,
                    isJtrq: this.form.isJtrq,
                    isZk: this.form.isZk,
                    mbgsCode: this.form.bhFormatCode,
                    mblxCode: 'yhbhmb',
                },
                function (data) {
                    this.templateList = data;
                }
            );
        },
        mbSelect(item) {
            this.form.mbId = item.id;
            this.form.mbName = item.mbName;
            this.form.fsCode = !!item.fsCode ? item.fsCode : '';
        },
        queryBzfs(next) {
            //默认选中第一个
            this.$get(
                this.getStore('twUrl') + '/dictionary/select/bzfs',
                function (data) {
                    this.form.bzfsCode = data[0].key;
                    this.form.bzfsName = data[0].value;
                    if (!!next) {
                        next();
                    }
                }
            );
        },
        queryBhgs(next) {
            //默认选中第一个  字典
            this.$get(
                this.getStore('twUrl') + '/dictionary/select/bhgs',
                function (data) {
                    this.form.bhFormatCode = data[0].key;
                    this.form.bhFormatName = data[0].value;
                    if (!!next) {
                        next();
                    }
                }
            );
        },
        queryYh(next) {
            //默认选中第一个
            this.$get(
                this.getStore('offUrl') + '/bank/bankselectlist.json',
                function (data) {
                    this.form.bankId = data[0].rowguid;
                    this.form.bankName = data[0].bankname;
                    if (!!next) {
                        next();
                    }
                }
            );
        },
        queryBhlx(next) {
            //默认选中第一个
            this.$get(
                this.getStore('twUrl') + '/dictionary/select/bhlx',
                function (data) {
                    this.form.bhTypeCode = data[0].key;
                    this.form.bhTypeName = data[0].value;
                    if (!!next) {
                        next();
                    }
                }
            );
        },
    },
    created() {
        var that = this;
        if (!!sessionStorage.getItem('id')) {
            this.$get(
                this.getStore('bankguart') +
                    '/gua_order/' +
                    sessionStorage.getItem('id'),
                (data) => {
                    this.zbwjFile = data.guaOrder.zbwjFile;
                    this.yyzzFile = data.guaOrder.yyzzFile;
                    this.bysFile = data.guaOrder.bysFile;
                    this.form.otherFileguid = data.guaOrder.otherFileguid;
                    this.zkzlFileguid = data.guaOrder.zkzlFileguid;
                    this.form = data.guaOrder;
                    if (
                        data.guaOrder.auditStatus == '3' ||
                        data.guaOrder.auditStatus == '4'
                    ) {
                        this.saveButtonContorl = false;
                    }
                }
            );
        } else {
            this.zbwjFile = this.GenNonDuplicateID();
            this.yyzzFile = this.GenNonDuplicateID();
            this.bysFile = this.GenNonDuplicateID();
            this.form.otherFileguid = this.GenNonDuplicateID();
            this.zkzlFileguid = this.GenNonDuplicateID();
            new Chain()
                .link(function (that, next) {
                    that.queryBzfs(next);
                })
                .link(function (that, next) {
                    that.queryBhgs(next);
                })
                .link(function (that, next) {
                    that.queryYh(next);
                })
                .link(function (that, next) {
                    that.queryBhlx(next);
                })
                .link(function (that, next) {
                    Object.keys(that.$route.query).forEach(function (key) {
                        if (!!that.$route.query[key])
                            that.form[key] = that.$route.query[key];
                    });
                    next();
                })
                .run(this);
        }
    },
    mounted: function () {
        this.bhmbFileguid = this.GenNonDuplicateID();
        this.form.bhmbFileguid = this.GenNonDuplicateID();

        this.form.issueTime =
            new Date(new Date().getTime() + 86400000).getFullYear() +
            '-' +
            (new Date(new Date().getTime() + 86400000).getMonth() + 1) +
            '-' +
            new Date(new Date().getTime() + 86400000).getDate(); //签发时间为当前日期的后一天

        this.form.ywyName = this.$store.getters.getUser.mdiusername;
    },
};
